import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Deliverables() {
  const items = [{
    title: 'Guía Paso a Paso',
    desc: 'El protocolo para diagnosticar cuál de tus 4 cuerpos está saboteando tus finanzas hoy mismo.'
  }, {
    title: 'Blindaje Mental',
    desc: 'Técnicas de enfoque profundo para tomar decisiones de inversión con claridad absoluta.'
  }, {
    title: 'Optimización Biológica',
    desc: 'Cómo usar el sueño y la nutrición como herramientas para maximizar tu capacidad de producción.'
  }, {
    title: 'Limpieza Emocional',
    desc: 'El método para desvincular tu valor personal de tu cuenta bancaria y operar desde la abundancia.'
  }, {
    title: 'La Agenda 4x4',
    desc: 'Un sistema de rutinas para ejecutar tu plan de libertad financiera sin caer en el burnout.'
  }];
  return <section className="bg-brand-cream text-brand-dark py-24 px-6 border-b border-gray-200" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center text-brand-dark" data-id="element-18">
            Lo que obtendrás en el interior
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-19">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-20">
              <div className="bg-white p-8 rounded-sm shadow-sm border-t-4 border-brand-gold h-full" data-id="element-21">
                <CheckCircle2 className="w-8 h-8 text-brand-gold mb-4" data-id="element-22" />
                <h3 className="font-bold text-xl mb-3 text-brand-green" data-id="element-23">
                  {item.title}
                </h3>
                <p className="text-brand-dark/70 leading-relaxed font-light" data-id="element-24">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}